import { render, staticRenderFns } from "./io-field.editor.vue?vue&type=template&id=8be73250&scoped=true&"
import script from "./io-field.editor.vue?vue&type=script&lang=ts&"
export * from "./io-field.editor.vue?vue&type=script&lang=ts&"
import style0 from "./io-field.editor.vue?vue&type=style&index=0&id=8be73250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be73250",
  null
  
)

export default component.exports